

export const SheetJSFT = [
    "xlsx", "csv"
].map(function (x) { return "." + x; }).join(",");

